export const SIGNAL_NAMES = {
  context: 'context',
  metrics: 'metrics',
  events: 'events',
  logs: 'logs',
  traces: 'traces',
  spans: 'spans',
};
